import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { PATH_WORK_LOGS_PAYEE_TAB_IN_PROGRESS } from "../../../modules/WorkLogs/paths";
import { getPayerEngagementsWorkDefinitions } from "../../../services/payerEngagements/getPayerEngagementWorkDefinitions";

type Params = {
  payerId: string | null | undefined;
  payerPayeeEngagementId: string | null | undefined;
  skip?: boolean;
};

export const useWorkDefinitionRedirect = ({
  payerId,
  payerPayeeEngagementId,
  skip
}: Params) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const checkedEngagementRef = useRef<string | null>(null);

  useEffect(() => {
    const handleEngagementSelection = async () => {
      if (!payerPayeeEngagementId || !payerId) {
        return;
      }

      const engagementKey = `${payerId}/${payerPayeeEngagementId}`;
      if (checkedEngagementRef.current === engagementKey) {
        return;
      }
      checkedEngagementRef.current = engagementKey;

      try {
        setIsLoading(true);

        const definitions = await getPayerEngagementsWorkDefinitions(
          {
            engagementId: payerPayeeEngagementId,
            payerId
          },
          {
            page: {
              size: 1
            }
          }
        );

        if (definitions?.length) {
          const params = new URLSearchParams({
            payerId,
            engagementId: payerPayeeEngagementId
          });
          history.push(
            `${PATH_WORK_LOGS_PAYEE_TAB_IN_PROGRESS}?${params.toString()}`
          );
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (!!payerId && !!payerPayeeEngagementId && !skip) {
      handleEngagementSelection();
    }
  }, [history, payerId, payerPayeeEngagementId, skip]);

  return { isLoading };
};
